import { Minimize2, X } from "lucide-react";
import { cn } from "@/lib/utils";
import type { StatePill } from "./types";

type Props = {
  pill: StatePill;
  onClose: () => void;
  /**
   * Rendered while the call is ACTIVE in place of the X: minimizing keeps the
   * call alive behind the floating indicator, which is the safe default —
   * ending the call stays an explicit "End call" action in the controls.
   * Terminal states swap back to the X (dismiss + release the call slot).
   */
  onMinimize: () => void;
  showMinimize: boolean;
};

const CallPopupHeader = ({ pill, onClose, onMinimize, showMinimize }: Props) => (
  <div className="relative flex items-center justify-between px-5 pt-5 pb-3">
    <span
      className={cn(
        "inline-flex items-center gap-2 rounded-full border px-2.5 py-1 text-[10px] font-semibold tracking-wider",
        pill.classes,
      )}
    >
      {pill.pulse ? (
        <span className="relative flex w-1.5 h-1.5">
          <span
            className={cn(
              "absolute inline-flex w-full h-full rounded-full opacity-75 animate-ping",
              pill.dotClasses,
            )}
          />
          <span
            className={cn("relative inline-flex w-1.5 h-1.5 rounded-full", pill.dotClasses)}
          />
        </span>
      ) : (
        <span className={cn("w-1.5 h-1.5 rounded-full", pill.dotClasses)} />
      )}
      {pill.label}
    </span>

    {showMinimize ? (
      <button
        type="button"
        onClick={onMinimize}
        aria-label="Minimize call"
        title="Minimize — the call keeps going while you navigate"
        className="flex items-center justify-center w-8 h-8 rounded-md text-white/50 hover:text-white hover:bg-white/10 transition-colors"
      >
        <Minimize2 className="w-4 h-4" />
      </button>
    ) : (
      <button
        type="button"
        onClick={onClose}
        aria-label="Close call"
        className="flex items-center justify-center w-8 h-8 rounded-md text-white/50 hover:text-white hover:bg-white/10 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    )}
  </div>
);

export default CallPopupHeader;
